import "./RadioButton.scss";

type RadioButtonProps = {
  content: string;
  checked: boolean;
  onClick: () => void;
};

const RadioButton = ({ content, checked, onClick }: RadioButtonProps) => {
  return (
    <div
      className={"checkbox-form"}
      style={{ border: checked ? "2px solid #aac4f9" : "2px solid #e0e0e0" }}
    >
      <div className="items" onClick={onClick}>
        <label className="control-area">
          <label className="control control-radio">
            <input type="radio" name="radio" value={content} checked={checked} />
            <div
              className="control_indicator"
              data-testid={`questionnaire-radio-button-${content}`}
            ></div>
            <span className="variant-description">{content}</span>
          </label>
        </label>
      </div>
    </div>
  );
};

export default RadioButton;
